import { CctvDtoKeysEnum } from '@zaoblako/shared/modules/cctv/enums/cctv-dto-keys.enum';
import { TransitTaskStatusEnum } from '@zaoblako/shared/modules/cctv/enums/transit-task/transit-task-status.enum';
import { TransitTaskStatusI18nEnum } from '@zaoblako/shared/modules/cctv/i18n/transit-task-status.i18n.enum';
import { TransitTaskFindOneQueryDto, type TransitTaskFindOneQueryInterface } from '@zaoblako/shared/modules/cctv/dtos/transit-task/transit-task-find-one-query.dto';
import { TransitTaskFindDto } from '@zaoblako/shared/modules/cctv/dtos/transit-task/transit-task-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { idLikeSchema } from '@zaoblako/shared/modules/serde/schemas/id-like.schema';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';

import * as yup from 'yup';

/** Transit tasks list APIs filters */
export interface TransitTaskFiltersInterface extends TransitTaskFindOneQueryInterface {
  /** Car category identifiers */
  categoryIds?: number[];
  /** Transit task client identifiers */
  clientIds?: number[];
  /** Transit task statuses */
  statuses?: TransitTaskStatusEnum[];
  /** Transit task responsible identifiers */
  responsibleIds?: number[];
  /** If defined and not empty, then only transit tasks related to rooms with these IDs will be taken */
  roomIds?: number[];
  /** Sorting settings */
  sort?: string;
  /** Grouping subtotals */
  groupSums?: 'client' | 'tariff';
  /** Sorting of the forces */
  sumsSortableColumn?: string;
}

/** Transit tasks list APIs filters - DTO schema */
export const TransitTaskFiltersDto = SerdeDtoClass.from<TransitTaskFindOneQueryInterface, TransitTaskFiltersInterface>(
  TransitTaskFindOneQueryDto,
  CctvDtoKeysEnum.TRANSIT_TASK_FILTERS_DTO,
  {
    categoryIds: {
      optional: true,
      label: 'Номера категорий ТС',
      serializer: yup.array(idLikeSchema),
    },
    clientIds: {
      optional: true,
      label: 'Номера клиентов',
      serializer: yup.array(idLikeSchema),
    },
    statuses: {
      optional: true,
      label: 'Статусы',
      serializer: commonEnumValidator.forArray(TransitTaskStatusEnum, TransitTaskStatusI18nEnum),
    },
    responsibleIds: {
      optional: true,
      label: 'Номера ответственных',
      serializer: yup.array(idLikeSchema),
    },
    roomIds: {
      optional: true,
      label: 'Номера помещений',
      serializer: yup.array(idLikeSchema),
    },
    sort: {
      optional: true,
      label: 'Сортировка',
      serializer: SerdeDtoClass.getSortingCriteriaValidator(TransitTaskFindDto),
    },
    groupSums: {
      optional: true,
      label: 'Группировка подытогов',
      serializer: yup.mixed(),
    },
    sumsSortableColumn: {
      optional: true,
      label: 'Сортировать подытоги по',
      serializer: yup.string(),
    },
  },
);
